import React from 'react';

type LoadingContainerProps = {
  className?: string;
  state?: boolean;
};

function LoadingContainer({ state = false, className = '' }: LoadingContainerProps) {
  return (
    <div
      className={`loading-container ${
        state ? 'd-flex' : 'd-none'
      } align-items-center justify-content-center ${className}`}>
      <span className="ecs-font-icon-act-loading" />
    </div>
  );
}

export default LoadingContainer;
